import { Injectable } from '@angular/core';

// MODALS

@Injectable({
  providedIn: 'root'
})
export class CustomSignallerService {
    window:any=<any>window;
  
    rand = (num:any = 12) => {
      var text = "";
      var characters = "_ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (var i = 0; i < num; i++) { text += characters.charAt(Math.floor(Math.random() * characters.length)); }
      return text;
    };

    constructor() {}

    initServices = () => {
        console.log("Custom service started");
    };
}